module.exports = __webpack_public_path__ + "static/storybook-intro.5eb59c13.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Homepage/Demo/images/storybook-intro.gif
// module id = 835
// module chunks = 213534597649335